import { render, staticRenderFns } from "./CreateEditRecipient.vue?vue&type=template&id=02ff3312&"
import script from "./CreateEditRecipient.vue?vue&type=script&lang=js&"
export * from "./CreateEditRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports